import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

import { environment } from "@env/environment";
import { Client } from "@models/client.model";
import { PasswordFormModel } from "@models/password-form.model";
import { ProfileDetailsChangeModel } from "@models/profile-details-change.model";
import { AuthService } from "@services/auth.service";
import { forkJoin, map, Observable, switchMap } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class ClientService {
  public static get NO_CLIENT_FOR_INTERMEDIARY(): string {
    return "noClientSelectedForIntermediary";
  }

  constructor(
    private http: HttpClient,
    private readonly authService: AuthService
  ) {}

  getClient$(id: string): Observable<Client> {
    return this.http
      .get<Client>(`${environment.BASE_URL}client/${id}`)
      .pipe(map((data: Client): Client => data));
  }

  updatePassword$(
    id: string,
    { newPassword, oldPassword }: PasswordFormModel
  ): Observable<unknown> {
    // Encrypt both passwords with the server's RSA key before sending, so neither the old nor the
    // new password appears as plaintext in the request body.
    return forkJoin({
      oldPassword: this.authService.encryptPassword$(oldPassword),
      newPassword: this.authService.encryptPassword$(newPassword),
    }).pipe(
      switchMap(
        (encrypted): Observable<unknown> =>
          this.http.patch(
            `${environment.BASE_URL}client/${id}/password`,
            encrypted
          )
      )
    );
  }

  saveClient$(client: Partial<Client>, id: string): Observable<unknown> {
    return this.http.patch(`${environment.BASE_URL}client/${id}`, client);
  }

  requestChanges$(
    id: string,
    { change, type }: ProfileDetailsChangeModel
  ): Observable<unknown> {
    return this.http.post(`${environment.BASE_URL}client/${id}`, {
      type,
      change,
    });
  }
}
